import { Modal } from "@fluentui/react";
import React, { useEffect, useState, useContext } from "react";
import {
  Spinner,
  SpinnerSize
} from "@fluentui/react";
import ModalFooter from "../../../components/Modal/ModalFooter";
import ModalHeader from "../../../components/Modal/ModalHeader";
import { returnedStudyReasons } from "../../../service/StudyListService";
import "./Styles/ReturnStudyCss.css";
import { useTranslation } from "react-i18next";
import ModalMain from "../../../components/Modal/ModalMain";
import studylistContext from "../../../context/studylist/StudylistContext";
import loaderContext from "../../../context/loader/LoaderContext";
import themeContext from "../../../context/theme/ThemeContext";

const ReturnStudy = (props) => {
  const {
    hideModal,
    setShowReturnedStudyReasonModal,
    showReturnedStudyReasonModal,
  } = useContext(studylistContext);

  const { ref, setLoaderRunning } = useContext(loaderContext);
  const [loading,setLoading] = useState(false);

  const [reasons, setReasons] = useState([]);
  const [t] = useTranslation();

  let PrimaryButtonList = [
    {
      title: t("button.close"),
      onclick: ()=>{
        setShowReturnedStudyReasonModal({studyId:null,show:false});
        if(props.setShowReturnedStudyReasonModal != undefined){
          props.setShowReturnedStudyReasonModal(false);
        }
      }
    },
  ];

  const handleReturnedStudy = async () => {
    setLoading(true);
    const response = await returnedStudyReasons(
      props.studyId
    );
    if(response.status == 200 && response.data.result == "SUCCESS"){
      console.log("--- Setting length ----");
      setReasons(response.data.data);
      setLoading(false);
    }else{
      setLoading(false);
    }
    console.log(response);
    
  };

  useEffect(() => {
    handleReturnedStudy();
  }, []);

  useEffect(()=>{
    console.log("--- Setting reasons ---");
    console.log(reasons);
  },[reasons])

  const modalDetails = {
    header: <ModalHeader updatedModal={true} heading={t("return-study.title")} 
    handleCancel={()=>{
      setShowReturnedStudyReasonModal({studyId:null,show:false});
        if(props.setShowReturnedStudyReasonModal != undefined){
          props.setShowReturnedStudyReasonModal(false);
        }
       }} />,
    body: <ReturnStudyReasonBody reasons={reasons} loading={loading} />,
    footer: (
      <ModalFooter
        PrimaryButtonList={PrimaryButtonList}
        DefaultButtonList={[]}
      />
    ),
    width: "700px",
  };

  return (
    <>
    
      <ModalMain modalDetails={modalDetails} showModal={showReturnedStudyReasonModal} />
    </>
  );
};

export default ReturnStudy;

export const ReturnStudyReasonBody = (props) => {
  const { getThemeColor } = useContext(themeContext);
  const [t] = useTranslation();
  const tableStyle = {
    width: "100%",
    color: getThemeColor("primary-color"),
    fontWeight: "400",
    fontFamily: "Open Sans",
  };

  const headStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
  };

  const thheadStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
    borderBottom:'none'
  };

  const bodyRowDataStyle = {
    padding: "10px",
    textAlign: "left",
    border: "1px solid #878282",
  };

  const reasonBodyStyle = {
    padding: "10px",
    textAlign: "left",
    border: "1px solid #878282",
    wordBreak: "break-all",
  };

  const contentStyles = {
    root: {
      backgroundColor: "rgb(22, 21, 20, 0.7)",
    },
  };

  const noReason = {
    padding: "10px",
    textAlign: "center",
    color: "white"
  }

  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  return (
    <>
      { props.loading ? <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
      :
      <div className="upload-study-modal-container">
        <div className="container-content" style={{padding:'26px 13px'}}>
         {props.reasons.length > 0 ? <table style={tableStyle}>
            <thead>
              <tr>
              <th style={thheadStyle}>{t("return-study.returned-date/time")}</th>
              <th style={thheadStyle}>{t("return-study.radiologist")}</th>
              <th style={thheadStyle}>{t("return-study.reasons")}</th>
              </tr>
              <tr style={headStyle}></tr>
              <tr style={headStyle}></tr>
              <tr style={headStyle}></tr>
            </thead>
            <tbody id="unassign-modal_body">
              {props.reasons.map((reason, index) => (
                <tr key={index}>
                  <td style={bodyRowDataStyle}>{reason.createdAt}</td>
                  <td style={bodyRowDataStyle}>{reason.radiologistName}</td>
                  <td style={reasonBodyStyle}>{reason.reason}</td>
                </tr>
               ))} 
            </tbody>
          </table>:
          <p style={noReason}>{t("return-study.no-reasons")}</p>
          }
        </div>
      </div>}
    </>
  );
};
